export const scaleOptions = [
  {
    value: 0.25,
    label: '25%',
  },
  {
    value: 0.5,
    label: '50%',
  },
  {
    value: 0.75,
    label: '75%',
  },
  {
    value: 1,
    label: '100%',
  },
  {
    value: 1.25,
    label: '125%',
  },
  {
    value: 1.5,
    label: '150%',
  },
  {
    value: 1.75,
    label: '175%',
  },
  {
    value: 2,
    label: '200%',
  },
  {
    value: 2.25,
    label: '225%',
  },
  {
    value: 2.5,
    label: '250%',
  },
  {
    value: 2.75,
    label: '275%',
  },
  {
    value: 3,
    label: '300%',
  },
];

export const minScale = scaleOptions[0].value;
export const maxScale = scaleOptions[scaleOptions.length - 1].value;
